"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateColumnNames = duplicateColumnNames;
exports.failedToReadFile = failedToReadFile;
exports.fileTooLarge = fileTooLarge;
exports.missingColumns = missingColumns;
exports.noColumns = noColumns;
exports.missingWorksheet = missingWorksheet;
exports.tooManyColumns = tooManyColumns;
exports.unsupportedFileType = unsupportedFileType;
exports.buildError = buildError;

function formatSmallNumber(n, d) {
  var locale = navigator.language || navigator.browserLanguage || navigator.languages && navigator.languages.length && navigator.languages[0];
  return n.toLocaleString(locale, {
    maximumFractionDigits: d
  });
}

function duplicateColumnNames(columns) {
  var columnList = columns.map(function (column) {
    return "\"".concat(column, "\"");
  }).join(', ');
  return "The uploaded file has the following duplicated columns: ".concat(columnList);
}

function failedToReadFile(file) {
  return file && file.name ? "Failed to read the file \"".concat(file.name, "\".") : 'Failed to read the file.';
}

function fileTooLarge(givenSize, maxSize) {
  var mbSize = 1024 * 1024;
  var givenSizeMb = formatSmallNumber(givenSize / mbSize, 2);
  var maxSizeMb = formatSmallNumber(maxSize / mbSize, 2);
  return "The uploaded file is ".concat(givenSizeMb, " MB but the maximum file size is ").concat(maxSizeMb, " MB.");
}

function missingColumns(columns) {
  var columnList = columns.map(function (column) {
    return "\"".concat(column, "\"");
  }).join(', ');
  return "The uploaded file is missing the following required columns: ".concat(columnList, ".");
}

function noColumns() {
  return 'The uploaded file has no usable columns.';
}

function missingWorksheet() {
  return 'Uploaded spreadsheets need at least one worksheet.';
}

function tooManyColumns(columns) {
  var columnList = columns.map(function (column) {
    return "\"".concat(column, "\"");
  }).join(', ');
  return "The uploaded file has the following unrecognized columns: ".concat(columnList, ".");
}

function unsupportedFileType() {
  return "The uploaded file is not of a supported file type.";
}

function buildError(error) {
  return {
    columns: [],
    rows: [],
    error: error
  };
}